import CheckIcon from "../../../icons/CheckIcon";
import Icon1 from "../../../icons/whyAB/Icon1";

export function CustomCard(props: any) {
  return (
    <div className={`absolute ${props.alignment}`}>
      <div className="relative">
        <div
          className="absolute inset-0 bg-slate-100"
          style={{
            clipPath: "polygon(0% 0%, 85% 0%, 100% 50%, 100% 100%, 0% 100%)",
            transform: "scale(1.012)",
            zIndex: 0,
          }}
        ></div>
        <div
          className="flex items-center shadow-2xl  bg-white px-3 py-[6px] lg:py-[9px] lg:px-5 gap-[13px] "
          style={{
            clipPath: "polygon(0% 0%, 85% 0%, 100% 50%, 100% 100%, 0% 100%)",
            zIndex: 0,
          }}
        >
          <CheckIcon className="h-3 w-3 lg:h-auto lg:w-auto" />
          <p className="font-openSans font-semibold text-[7px] lg:text-web-body-md leading-3 lg:leading-[19px] text-brand-textGrey">
            {props.contentText}
          </p>
        </div>
      </div>
    </div>
  );
}
